export default {
    STORE_PATH: "administrator",

    // STATE
    COMPANIES: "COMPANIES",
    SELECTED_COMPANY: "SELECTED_COMPANY",
    IS_LOADING: "IS_LOADING",

    // ACTIONS
    GET_COMPANIES: "GET_COMPANIES",
    SELECT_COMPANY: "SELECT_COMPANY",
};